import styled, { css } from "styled-components";
import { tokens } from "../../../public/tokens";

const baseTextStyle = css`
  font-family: "Albert Sans", sans-serif;
  margin: 0;
`;

const flexColumn = (gap) => css`
  display: flex;
  flex-direction: column;
  gap: ${gap};
`;

const bodyTextStyle = css`
  ${baseTextStyle}
  font-size: ${tokens.typography.fontSize["lg-14px"]};
  line-height: ${tokens.typography.lineHeights[130]};
`;


export const SupportingDocumentsContainer = styled.div`
  ${flexColumn('30px')}
  padding: ${tokens.globals["spacing-lg"]};
  background-color: ${tokens.colors.surfaces["container-background"]};
  border: 1px solid ${tokens.colors.surfaces["border-divider"]};
  border-radius: ${tokens.globals['border-radius']};
`;

export const Section = styled.div`
  ${flexColumn('15px')}
`;

export const HeaderSection = styled.div`
  ${flexColumn('8px')}
`;

export const UploadList = styled.div`
  ${flexColumn('16px')}
`;

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: 10px;
`;


export const Title = styled.h4`
  ${baseTextStyle}
  font-weight: ${tokens.typography.fontWeights.bold};
  font-size: ${tokens.typography.fontSize["base-16px"]};
  line-height: ${tokens.typography.lineHeights[110]};
  color: ${tokens.colors.text.primary};
`;

export const Description = styled.p`
  ${bodyTextStyle}
  color: ${tokens.colors.text.secondary};
`;

export const FileTypeWarningText = styled.p`
  ${bodyTextStyle}
  font-weight: ${tokens.typography.fontWeights.semibold};
  color: ${tokens.colors.states.alert.default};
`;


export const EmptyStateContainer = styled.div`
  ${flexColumn('0')}
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  background-color: ${tokens.colors.neutral.grey[200]};
  border: 1px solid ${tokens.colors.surfaces["border-divider"]};
  border-radius: ${tokens.globals['border-radius']};
`;

export const EmptyStateIcon = styled.i`
  font-size: ${tokens.typography.fontSize["4xl-32px"]};
  color: ${tokens.colors.theme["highlight-color"]};
  margin-bottom: 10px;
`;

export const EmptyStateText = styled.p`
  ${bodyTextStyle}
  color: ${tokens.colors.text.secondary};
`;

export const FileRowContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  padding: 10px;
  min-height: 59px;
  background-color: ${tokens.colors.neutral.grey[100]};
  border: 1px solid ${props => props.$isDragOver ? tokens.colors.theme['highlight-color'] : tokens.colors.surfaces["border-divider"]};
  border-style: ${props => props.$isDragOver ? 'dashed' : 'solid'};
  border-radius: ${tokens.globals['border-radius']};
  cursor: ${props => props.$clickable && !props.$isUploaded ? 'pointer' : 'default'};
  transition: background-color 0.15s ease, border-color 0.15s ease, border-style 0.15s ease;

  &:hover {
    background-color: ${props => props.$clickable && !props.$isUploaded ?  tokens.colors.theme["hover-color"] : tokens.colors.theme["active-color"]};
  }

  ${props => props.$isUploaded && `
    background-color: ${tokens.colors.theme["active-color"]};
  `}

  ${props => props.$isDragOver && `
    background-color: ${tokens.colors.theme["hover-color"]};
  `}
`;

export const FileRowContent = styled.div`
  ${flexColumn('8px')}
  flex: 1;
`;

export const FileRowLabel = styled.p`
  ${baseTextStyle}
  font-size: ${tokens.typography.fontSize["lg-14px"]};
  line-height: ${tokens.typography.lineHeights[110]};
  color: ${tokens.colors.text.secondary};
`;

export const FileRowDescription = styled.p`
  ${baseTextStyle}
  font-size: ${tokens.typography.fontSize["md-12px"]};
  line-height: normal;
  color: ${tokens.colors.text.secondary};
`;

export const FileRowStatus = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const FileRowLink = styled.a`
  display: flex;
  align-items: center;
  gap: 5px;
  ${baseTextStyle}
  font-size: ${tokens.typography.fontSize["md-12px"]};
  line-height: ${tokens.typography.lineHeights[110]};
  color:  ${tokens.colors.text.link};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const FileRowHelper = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const FileRowHelperIcon = styled.i`
  color: ${tokens.colors.brand.red[500]};
  font-size: ${tokens.typography.fontSize["md-12px"]};
`;

export const FileRowHelperText = styled.p`
  ${baseTextStyle}
  font-size: ${tokens.typography.fontSize["md-12px"]};
  line-height: ${tokens.typography.lineHeights[100]};
  color:  ${tokens.colors.brand.red[500]};
`;

export const FileRowHelperBold = styled.span`
  font-weight: ${tokens.typography.fontWeights.bold};
`;

export const FileRowButtonLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  background-color:${props => props.$disabled ? '#acacac' : 'var(--button-color, #467fcf)'};
  border: 1px solid ${props => props.$disabled ? '#acacac' : 'var(--button-color, #467fcf)'};
  border-radius: var(--border-radius);
  padding: 8px 20px;
  height: 33px;
  color: var(--white);
  font-weight: 600;
  font-size: 14px;
  cursor: ${props => props.$disabled ? 'not-allowed' : 'pointer'};
  white-space: nowrap;
  text-decoration: none;
  opacity: ${props => props.$disabled ? 0.6 : 1};
  pointer-events: ${props => props.$disabled ? 'none' : 'auto'};
  :hover{
    background-color: var(--button-hover-color);
    border: 1px solid var(--button-hover-color);
    color: var(--white);
  }
  :active{
    background-color: var(--button-active-color);
    border: 1px solid var(--button-active-color);
    color: var(--white);
    }
`;
 

export const FileRowInput = styled.input`
  display: none;
`;
